"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HELP_CENTER_ARTICLES = void 0;
exports.HELP_CENTER_ARTICLES = {
    PAY_FREQUENCY_EXPLAINER: 'https://support.upandup.co/hc/en-us/articles/26819112006292'
};
